import React from 'react';
import PropTypes from 'prop-types';

import { pure } from '@dbk/ui-react-utils';

import Arrow from '../../common/arrow';
import styles from './navigation-arrow.styles';

function NavigationArrow(props) {
  const {
    size,
    direction,
    thickness,
    color,
    disabled,
    tabIndex,
    ariaLabel
  } = props;

  const style = Object.assign({}, styles[size]);

  if (!!thickness) {
    style.thickness = styles.thickness[thickness];
  }

  if (!!color) {
    style.color = styles.color[(disabled ? `${color}Disabled` : color)];
  }

  return (
    <div id="Arrow" tabIndex={tabIndex} aria-label={ariaLabel}>
    <Arrow
      direction={direction}
      width={(direction === 'down') || (direction === 'up')? style.height : style.width}
      height={(direction === 'down') || (direction === 'up') ? style.width : style.height}
      color={style.color}
      thickness={style.thickness}
    />
    </div>
  );
}

NavigationArrow.defaultProps = {
  size: 'normal',
  direction: 'right',
  disabled: false,
  tabIndex: -1,
  ariaLabel:''
};

NavigationArrow.propTypes = {
  size: PropTypes.oneOf(['normal', 'large']),
  direction: PropTypes.oneOf(['right', 'down', 'left', 'up']),
  thickness: PropTypes.oneOf(['thin', 'normal', 'thick']),
  color: PropTypes.oneOf(['primary', 'secondary']),
  disabled: PropTypes.bool,
  tabIndex: PropTypes.number,
  ariaLabel: PropTypes.string
};

export default pure(NavigationArrow);
